// FloatingActionButtons.js
'use strict';
import { connect } from 'react-redux';

import FloatingActionButtons from '../component/FloatingActionButtons.jsx';
import withRouter from '../component/WithRouter.jsx';

import getMeData from '../selector/getMeData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { PREVIEW_PRESET } from '../RemoteConfigKeys.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import getShouldShowLanding from '../selector/getShouldShowLanding.js';

const mapStateToProps = (state, { location }) => {
  const token = getMeData(state, 'token');
  const isRemoteConfigMerged = token
    ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
    : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
      getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE);

  return {
    isDisplayingAgeVerify:
      getRemoteConfigData(state, PREVIEW_PRESET) === 'blurred',
    isRemoteConfigMerged,
    isJoin: getIsMatchedPathname({
      pathname: location.pathname,
      dataKey: 'isOnJoin',
    }),
    isLandingPageShown: getShouldShowLanding(state),
  };
};

export default withRouter(
  connect(mapStateToProps, null)(FloatingActionButtons)
);
